import { Component, h, Host } from "@stencil/core";

@Component({
    tag: "ux-list-item",
    styleUrl: "list-item.scss",
    shadow: true
})
export class ListItem {
    render() {
        return (
            <Host>
                <li>
                    <slot></slot>
                </li>
            </Host>
        );
    }
}
